import { Chip, Tooltip } from '@mui/material';

const STATUS_PRESETS = {
  active: { color: 'success', label: 'Activo' },
  inactive: { color: 'error', label: 'Inactivo' },
  warning: { color: 'warning' },
  info: { color: 'info' },
  neutral: { color: 'default' },
  success: { color: 'success' },
  error: { color: 'error' },
};

const StatusChip = ({
  status,
  label,
  color,
  icon,
  tooltip,
  variant = 'filled',
  size = 'small',
  uppercase = false,
  sx = {},
  ...props
}) => {
  const preset = status ? STATUS_PRESETS[status] || {} : {};
  const finalLabel = label ?? preset.label ?? status ?? '';
  const chip = (
    <Chip
      size={size}
      color={color ?? preset.color ?? 'default'}
      variant={variant}
      icon={icon ?? preset.icon}
      label={uppercase && typeof finalLabel === 'string' ? finalLabel.toUpperCase() : finalLabel}
      sx={{ fontWeight: 600, letterSpacing: '0.03em', p: 0.5, ...preset.sx, ...sx }}
      {...props}
    />
  );

  if (!tooltip) {
    return chip;
  }

  return <Tooltip title={tooltip}>{chip}</Tooltip>;
};

export default StatusChip;
